module.exports = __webpack_public_path__ + "static/tiktok-small-4e9b4691989ff97e4b8d789af3701e33.webp";